// import { useState } from "react";
import "../css/photos.css";

export default function Photos() {
    //   const [showEmergency, setShowEmergency] = useState(false);

    return (
        <div>
            <h1>L'équipe du mariage</h1>
            <p>Voici une petite présentation et les informations de l'équipe du mariage ! <br/>
            Merci de les contacter eux en priorité en cas de question ou d'urgence.</p>

            <p>A noter que pour le jour J, il ne faudra pas courir derrière les mariés pour leur poser des questions.</p>

            <div className="team-members flex">
                {/* <div className="team-member">
                    <h2>Céline</h2>
                    <img src="images/vilaines/celine.jpg" alt="Céline" className="team-photo" />
                    <p>N° tel : <a href="tel:0494281678">0494 / 28.16.78</a></p>
                </div>
                <div className="team-member">
                    <h2>Maxime</h2>
                    <img src="images/vilaines/maxime2.jpg" alt="Maxime" className="team-photo" />
                    <p>N° tel : <a href="tel:0475337800">0475 / 33.78.00</a></p>
                </div>
                <div className="team-member">
                    <h2>Kelly</h2>
                    <img src="images/vilaines/kelly.jpg" alt="Kelly" className="team-photo" />
                    <p>N° tel : <a href="tel:0494661720">0494 / 66.17.20</a></p>
                </div> */}
            </div>
                {/* BOUTON POUR AFFICHER L'URGENCE */}
                {/* {!showEmergency && (
                    <button 
                        onClick={() => setShowEmergency(true)} 
                        className="emergency-button btn button"
                    >
                        Contacter la maitresse de cérémonie en cas d'urgence
                    </button>
                )} */}

                {/* TEAM MEMBER CACHÉE */}
                {/* {showEmergency && (
                    <div className="team-member">
                        <h2>Aurore </h2>
                        <h4>(uniquement au sujet de la cérémonie)</h4>
                        <img src="images/vilaines/aurore.jpg" alt="Aurore" className="team-photo" />
                        <p>N° tel : <a href="tel:0474467717">0474 / 46.77.17</a></p>
                    </div>
                )} */}
        </div>
    );
}

